import type { ClientErrorReason } from '@apovisio/contracts';

const reported = new Set<ClientErrorReason>();

/**
 * Signale une erreur constatée par le navigateur (raison seule, liste fermée). Au plus une
 * fois par chargement de page, sans nouvel essai ; aucune donnée ni identifiant transmis.
 */
export function reportClientError(reason: ClientErrorReason): void {
  if (reported.has(reason)) return;
  reported.add(reason);
  try {
    void fetch('/api/telemetry/client-errors', {
      method: 'POST',
      headers: { 'content-type': 'application/json', 'x-apovisio-request': '1' },
      credentials: 'omit',
      keepalive: true,
      body: JSON.stringify({ reason }),
    }).catch(() => undefined);
  } catch {
    // Télémétrie facultative : aucune conséquence pour l'utilisateur.
  }
}

/** Réinitialisation (tests uniquement). */
export function resetTelemetryForTests(): void {
  reported.clear();
}
